import React, { useState, useRef } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { useNavigate } from 'react-router-dom'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import Bugsnag from '@bugsnag/js'

import InviteStaffForm from './InviteStaffForm'

// import { format, differenceInDays, addDays } from "date-fns";

import { useMutation, useQueryClient, useQuery } from 'react-query'
// API
import { profileDepartments } from 'services/api/dropdown'
import { postInviteStaffIndividual } from 'services/api/modules/staff-management/staffManagementDashboard'

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .nullable()
    .required('Name is required')
    .matches(/^[a-zA-Z-@ /.']+$/, "Name must be valid eg. Alphabet with @, ', -, . and /"),
  email: Yup.string().nullable().email('Invalid email format').required('Email is required'),
  designation: Yup.string().nullable().required('Job Designation is required'),
})

const InviteStaff = () => {
  const queryClient = useQueryClient()
  const formikRef = useRef()

  const navigate = useNavigate()
  const [pageState, setPageState] = useState('FILL_DETAILS')

  const handleCloseModal = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    }
    navigate(-1)
  }

  const { data: departmentList } = useQuery('employeeProfileDepartmentList', async () => {
    const { data } = await profileDepartments()
    return data
  })

  const mutation = useMutation(postInviteStaffIndividual, {
    onSuccess: async (response) => {
      queryClient.invalidateQueries('staffListData')
      queryClient.invalidateQueries('getUninvitedStaff')
      const sleep = (ms) => new Promise((r) => setTimeout(r, ms))
      if (pageState === 'FILL_DETAILS') {
        await sleep(500)
        setPageState('SUCCESSFUL_REQUEST')
      }
    },
    onError: (error) => {
      if (error.status === 422) {
        const { message } = error.data
        formikRef.current.setFieldError('email', message)
      } else {
        Bugsnag.notify(error.data)
      }
    },
  })

  const handleIndividualInvite = async (values) => {
    mutation.mutate(values)
  }

  if (pageState === 'SUCCESSFUL_REQUEST') {
    return (
      <AdxInfoModal
        open={true}
        muiIcon="group_add"
        iconColor="alternate.main"
        title="Staff Invited"
        subtitle={`Your staff has been invited through the email registered. You can check with them to verify the registration.`}
        modalWidth="500px"
        footerButtons
        firstBtnLabel={'Close'}
        firstBtnHandle={() => navigate(-1)}
      ></AdxInfoModal>
    )
  }
  return (
    <Formik
      enableReinitialize
      initialValues={{
        name: null,
        email: null,
        designation: null,
        department_id: null,
      }}
      validationSchema={validationSchema}
      onSubmit={handleIndividualInvite}
      innerRef={formikRef}
    >
      {(formikProps, { handleSubmit } = formikProps) => (
        <Form>
          <AdxFormModal
            open={true}
            onClose={handleCloseModal}
            handleClose={handleCloseModal}
            handleAction={handleSubmit}
            disableEscapeKeyDown
            disableAutoFocus
            sx={{
              '&.MuiModal-root': { overflowY: 'auto' },
            }}
            sxModal={{
              minWidth: { xs: 'none', sm: 'calc(100vw - 30px)', lg: '460px' },
            }}
            title="Invite a staff"
            subtitle={null}
            enableFooter
            actionText="Invite"
          >
            {pageState === 'FILL_DETAILS' && (
              <InviteStaffForm formikProps={formikProps} departmentList={departmentList} />
            )}
          </AdxFormModal>
        </Form>
      )}
    </Formik>
  )
}

export default InviteStaff
